import { gql } from "apollo-boost"

export const UPDATE_SCHEDULE_PLACE = gql`
  mutation Mutation($schedulePlaceData: CreateSchedulePlaceInput!) {
  UpdateSchedulePlace(schedulePlaceData: $schedulePlaceData)
}
`